import { TableCell } from "./TableCell";

export function ActionCell(props) {
  return <TableCell style={{ minWidth: "16ch" }}>{props.children}</TableCell>;
}
